module.exports = __webpack_public_path__ + "img/31f8ed1.jpg";